import { IconCheck } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { getModuleName } from "src/features/planning/modules.js";
import { useGetCompanyModulesQuery } from "src/features/planning/api/planningApi.js";
import { useLoadedCompanyDomain } from "src/routes/routeDataHooks.js";
import { getProduct } from "src/features/products/products.js";
import { Card, CardHeader } from "../planning/components/Card";

export const PlanningModulesSettingsPage = () => {
	const { t } = useTranslation();
	const companyDomain = useLoadedCompanyDomain();
	const { data: modules } = useGetCompanyModulesQuery({
		companyId: companyDomain.id,
	});

	return (
		<Card>
			<CardHeader className="flex-col items-start gap-1">
				<div className="font-medium">{getProduct("planning").name}</div>
				<p className="text-sm text-gray-500">
					{t("Modules activated for this company domain.")}
				</p>
			</CardHeader>
			{/* WHY no Switch: nothing here is toggleable — this is a summary, not the activation control (that's dev-tools). */}
			<ul>
				{(modules ?? []).map((module) => (
					<li
						key={module.id}
						className="flex items-center gap-4 border-b border-gray-200 px-4 py-4 last:border-b-0"
					>
						<IconCheck className="shrink-0 text-green-600" />
						<div>
							<div className="text-gray-700 text-sm font-medium">
								{getModuleName(t, module)}
							</div>
							{module.description && (
								<div className="text-gray-500 text-sm">
									{module.description}
								</div>
							)}
						</div>
					</li>
				))}
			</ul>
		</Card>
	);
};
